var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visibleProxy,
        title: "Gán gói cho nhiều trường",
        width: "680px",
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "ps-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleProxy = $event
        },
      },
    },
    [
      _c("div", { staticClass: "ps-dialog-intro" }, [
        _c("div", { staticClass: "ps-dialog-intro__icon" }, [
          _c("i", { staticClass: "el-icon-connection" }),
        ]),
        _c("div", [
          _c("h3", [_vm._v("Gán cùng một gói cho nhiều trường")]),
          _c("p", [
            _vm._v("Chọn các trường cần gán, sau đó chọn gói đang sử dụng."),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "ps-bulk-school-summary" }, [
        _c("span", [_vm._v("Trường sẽ được gán")]),
        _c("strong", [
          _vm._v(
            _vm._s(_vm.selectedSchoolIds.length) +
              " / " +
              _vm._s(_vm.schools.length)
          ),
        ]),
      ]),
      _c(
        "el-form",
        { staticClass: "ps-dialog-form", attrs: { "label-position": "top" } },
        [
          _c("el-form-item", { attrs: { label: "Chọn trường" } }, [
            _c(
              "div",
              { staticClass: "ps-bulk-school-picker" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      size: "small",
                      filterable: "",
                      clearable: "",
                      placeholder: "Chọn trường",
                      disabled: !_vm.schools.length,
                    },
                    on: { change: _vm.addSchool },
                    model: {
                      value: _vm.schoolToAdd,
                      callback: function ($$v) {
                        _vm.schoolToAdd = $$v
                      },
                      expression: "schoolToAdd",
                    },
                  },
                  _vm._l(_vm.schools, function (school) {
                    return _c(
                      "el-option",
                      {
                        key: school.id,
                        attrs: {
                          value: school.id,
                          label: `${school.id} - ${school.schoolName}`,
                          disabled: _vm.selectedSchoolIds.includes(school.id),
                        },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(school.id))]),
                        _vm._v(" -\n            "),
                        _c("span", [_vm._v(_vm._s(school.schoolName))]),
                      ]
                    )
                  }),
                  1
                ),
                _vm.selectedSchools.length
                  ? _c(
                      "div",
                      { staticClass: "ps-bulk-school-tags" },
                      _vm._l(_vm.selectedSchools, function (school) {
                        return _c(
                          "el-tag",
                          {
                            key: school.id,
                            staticClass: "ps-bulk-school-tag",
                            attrs: {
                              type: "primary",
                              effect: "plain",
                              closable: "",
                            },
                            on: {
                              close: function ($event) {
                                return _vm.removeSchool(school.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(school.id) +
                                " - " +
                                _vm._s(school.schoolName) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                      1
                    )
                  : _c(
                      "span",
                      { staticClass: "ps-bulk-school-picker__empty" },
                      [_vm._v("\n          Chưa có trường được chọn\n        ")]
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      !_vm.schools.length
        ? _c("el-alert", {
            staticClass: "ps-dialog-alert",
            attrs: {
              type: "info",
              closable: false,
              "show-icon": "",
              title:
                "Chưa tải được danh sách trường. Vui lòng đóng dialog và thử lại.",
            },
          })
        : _vm._e(),
      _c(
        "el-form",
        {
          ref: "bulkAssignForm",
          staticClass: "ps-dialog-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Gói áp dụng", prop: "packageId" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "ps-full-width",
                  attrs: {
                    filterable: "",
                    placeholder: "Chọn gói đang sử dụng",
                    disabled: !_vm.selectedSchoolIds.length,
                  },
                  model: {
                    value: _vm.form.packageId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "packageId", $$v)
                    },
                    expression: "form.packageId",
                  },
                },
                _vm._l(_vm.packages, function (item) {
                  return _c(
                    "el-option",
                    {
                      key: item.id,
                      attrs: {
                        label: `${item.code} · ${item.name}`,
                        value: item.id,
                      },
                    },
                    [
                      _c("div", { staticClass: "ps-option-row" }, [
                        _c("span", [
                          _c("b", [_vm._v(_vm._s(item.code))]),
                          _vm._v(" · " + _vm._s(item.name)),
                        ]),
                        _c("span", { staticClass: "ps-option-limit" }, [
                          _vm._v(
                            "Số lượng tối đa: " +
                              _vm._s(_vm._f("formatNumber")(item.limit))
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectedPackage
        ? _c("div", { staticClass: "ps-assignment-preview" }, [
            _c("div", { staticClass: "ps-preview-item" }, [
              _c("span", [_vm._v("Giới hạn cơ bản mỗi trường")]),
              _c("b", [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.selectedPackage.limit)) +
                    " học sinh"
                ),
              ]),
            ]),
            _c("div", { staticClass: "ps-preview-item" }, [
              _c("span", [_vm._v("Giới hạn hiệu lực ban đầu")]),
              _c("b", [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.selectedPackage.limit)) +
                    " học sinh"
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "ps-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visibleProxy = false
                },
              },
            },
            [_vm._v("Hủy")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.saving,
                disabled: !_vm.selectedSchoolIds.length,
              },
              on: { click: _vm.handleConfirm },
            },
            [
              _c("i", { staticClass: "el-icon-check" }),
              _vm._v(
                " Gán cho " +
                  _vm._s(_vm.selectedSchoolIds.length) +
                  " trường\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }